// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
export var generateMashupXMLTemplate = function (base64) {
    return "<?xml version=\"1.0\" encoding=\"utf-16\"?><DataMashup xmlns=\"http://schemas.microsoft.com/DataMashup\">".concat(base64, "</DataMashup>");
};
export var generateSingleQueryMashup = function (queryName, query) {
    return "section Section1;\n    \n    shared #\"".concat(queryName, "\" = \n    ").concat(query, ";");
};
export var generateCustomXmlFilePath = function (i) { return "customXml/item".concat(i, ".xml"); };
